// extracted by mini-css-extract-plugin
export default {"appWrapper":"main_appWrapper__Hzpsi","gamepadDisplay":"main_gamepadDisplay__lqcjV"};